var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrokeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69064 0.940641C3.8615 0.769786 4.1385 0.769786 4.30936 0.940641L7.80936 4.44064C7.98021 4.6115 7.98021 4.8885 7.80936 5.05936C7.6385 5.23021 7.36149 5.23021 7.19064 5.05936L4 1.86872L0.809359 5.05936C0.638505 5.23021 0.361495 5.23021 0.190641 5.05936C0.0197864 4.8885 0.0197864 4.6115 0.190641 4.44064L3.69064 0.940641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeUp);
export default __webpack_public_path__ + "static/media/Stroke-up.2e6cf4431af8cdf5614139c6f6392ccd.svg";
export { ForwardRef as ReactComponent };